<div class="container">
  <ng-template pdqHeaderContent>
    @if (showList) {
      <div class="header">
        <pdq-button (onClick)="onNew()" variant="primary">
          {{ mode === 'standalone' ? 'New standalone widget' : '+ New Smart Cart' }}
        </pdq-button>
      </div>
    } @else if (isEditingBlock) {
      <!-- No header action while editing a block. -->
    } @else if (isStandaloneForm) {
      <!-- Standalone form: Back + "Order Protection" title come from LayoutService, so only Save here. -->
      <div class="header__actions">
        <pdq-button variant="primary" [disabled]="saveDisabled" [loading]="saving" (onClick)="onSave()">
          Save
        </pdq-button>
      </div>
    } @else {
      <div class="header__actions">
        <pdq-button variant="tertiary" (onClick)="onCancel()">Cancel</pdq-button>
        <pdq-button variant="primary" [disabled]="saveDisabled" [loading]="saving" (onClick)="onSave()">
          Save
        </pdq-button>
      </div>
    }
  </ng-template>

  @if (showList) {
    <pdq-tabs-group variant="underline" [leftMargin]="'none'" (onChange)="onTabChange($event)">
      <pdq-tab label="Smart Carts" value="smart-carts" [active]="mode === 'smart-carts'"></pdq-tab>
      <pdq-tab label="Standalone Widgets" value="standalone" [active]="mode === 'standalone'"></pdq-tab>
    </pdq-tabs-group>
  }

  <div class="grid-container">
    <div class="grid-container__left-col">
      @if (mode === 'standalone') {
        @if (showList) {
          <standalone-widgets-list></standalone-widgets-list>
        } @else {
          <standalone-widget-form (formReady)="onStandaloneFormReady($event)"></standalone-widget-form>
        }
      } @else {
        @if (showList) {
          <smart-cart-list (liveStateChanged)="onLiveStateChanged()"></smart-cart-list>
        } @else {
          <smart-cart-form></smart-cart-form>
        }
      }
    </div>
    <div class="grid-container__right-col">
      <pdq-card variant="popover" color="white">
        <div class="preview-card">
          <div class="preview-card__header">
            <pdq-heading element="h5">Preview</pdq-heading>
            @if (mode !== 'standalone' && showPreviewInShopify) {
              <pdq-link
                size="small"
                label="Preview In Shopify"
                [clickable]="true"
                [external]="true"
                (onClick)="onPreviewInShopify()"></pdq-link>
            }
          </div>
          <pdq-divider></pdq-divider>
          <div class="preview-card__content">
            @if (mode === 'standalone') {
              @if (standalonePreviewForm; as orderProtectionForm) {
                <order-protection-preview [formGroup]="orderProtectionForm"></order-protection-preview>
              } @else {
                <div class="preview-card__empty">
                  <p>No preview yet.</p>
                  <p>The widget preview will appear here</p>
                </div>
              }
            } @else if (showList && liveCartPreviewConfig) {
              <smart-cart-preview-drawer [config]="liveCartPreviewConfig"></smart-cart-preview-drawer>
            } @else if (showList && !liveCartLoading) {
              <div class="preview-card__empty">
                <p>No live cart.</p>
                <p>publish one of them to see the preview here</p>
              </div>
            } @else if (!showList && smartCartForm?.previewConfig) {
              <smart-cart-preview-drawer [config]="smartCartForm?.previewConfig ?? null"></smart-cart-preview-drawer>
            }
          </div>
        </div>
      </pdq-card>
    </div>
  </div>
</div>
